/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Batch_Subtitle_Export_DescriptionInputs */



/**
* | output |
* | --- |
* | "Select event groups and export formats to batch export subtitles" |
*
* @param {Batch_Subtitle_Export_DescriptionInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const batch_subtitle_export_description = /** @type {((inputs?: Batch_Subtitle_Export_DescriptionInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Batch_Subtitle_Export_DescriptionInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Sélectionnez des groupes d’événements et des formats d’export pour exporter les sous-titres par lot")
	if (locale === "de") return /** @type {LocalizedString} */ ("Ereignisgruppen und Exportformate auswählen, um Untertitel stapelweise zu exportieren")
	if (locale === "it") return /** @type {LocalizedString} */ ("Seleziona gruppi di eventi ed esporta formati per esportare in batch i sottotitoli")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Выберите группы событий и форматы экспорта для пакетного экспорта субтитров.")
	if (locale === "es") return /** @type {LocalizedString} */ ("Seleccione grupos de eventos y formatos de exportación para exportar subtítulos por lotes")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("选择事件组和导出格式，批量导出字幕。")
	if (locale === "ja") return /** @type {LocalizedString} */ ("イベントグループとエクスポート形式を選択して字幕を一括エクスポートします")
	if (locale === "hi") return /** @type {LocalizedString} */ ("उपशीर्षकों को बैच में निर्यात करने के लिए इवेंट समूह और निर्यात प्रारूप चुनें।")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Selecione grupos de eventos e formatos de exportação para exportar legendas em lote.")
	return /** @type {LocalizedString} */ ("Select event groups and export formats to batch export subtitles")
});